module.exports = __webpack_public_path__ + "img/blog-page.924250bf.jpg";